import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ReportSectionHeading from '../ReportSectionHeading'
import BadInformationDetailDetectionOverview from './BadInformationDetailDetectionOverview'
import PriorityRiskTable from './sections/PriorityRiskTable'
import CriminalRecordRiskTable from './sections/CriminalRecordRiskTable'
import { Stack } from '@mantine/core'

interface BadInformationDetailDetectionProps {
  data: any
  title: string
  sectionIndex?: string
}

export default function BadInformationDetailDetection({
  data,
  title,
  sectionIndex,
}: BadInformationDetailDetectionProps) {
  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <BadInformationDetailDetectionOverview data={data} />
      <Stack gap="md" className="mt-2">
        <PriorityRiskTable data={data} />
        <CriminalRecordRiskTable data={data} />
      </Stack>
    </ReportWrapper>
  )
}
